const DEFAULT_DISPLAY = 'Invalid Date';

const DisplayDate = ({ children }) => {

    if (!children) { return DEFAULT_DISPLAY; }

    let value = children;
    if (typeof (children) === 'string') {
        value = Number(children);
    }

    let date = new Date(value);
    if (date < new Date('2018-01-01')) {
        // check if milliseconds are included if date is
        const hasSeconds = String(value).length === 13;
        date = new Date(value * (hasSeconds ? 1 : 1000));

        if (date < new Date('2018-01-01')) {
            return DEFAULT_DISPLAY;
        }
    }

    const day = date.getDate();
    if (isNaN(day)) {
        return DEFAULT_DISPLAY;
    }

    const year = date.getFullYear();
    const month = date.toLocaleString('default', { month: 'long' });

    const props = {
        'data-tooltip': date.toLocaleString()
    };

    return (
        <span {...props}>
            {`${day} ${month} ${year}`}
        </span>
    );
}

export { DisplayDate };
